import { json } from "react-router-dom";

export function loader({ params }: { params: { code?: string } }): Response {
  const { code } = params as { code: string };
  return json({ code }, { status: 200 });
}
